import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import "assets/theme/admin_form.css";

const EditCoreValue = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    display_order: "",
  });

  const [loading, setLoading] = useState(false);

  // Fetch Data
  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await apiFetch(`leader_admin/get_core_values_by_id/${id}`);
      const data = res.data || {};

      setFormData({
        title: data.title || "",
        description: data.description || "",
        display_order: data.display_order || "",
      });
    } catch (error) {
      console.error("Fetch Error:", error);
      alert(error.message || "डेटा मिळवताना त्रुटी आली");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        title: formData.title,
        description: formData.description,
        display_order: formData.display_order,
      };

      await apiFetch(`leader_admin/update_core_values/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      alert("मूल्य यशस्वीरित्या अपडेट झाले");
      navigate("/core_values_list");
    } catch (error) {
      console.error("Update Error:", error);
      alert(error.message || "अपडेट करताना त्रुटी आली");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn-admin-back"
            >
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ मूलभूत मूल्य संपादन (Edit Core Values)
              </h4>
              <small className="text-white-50">Update core values details</small>
            </div>
          </div>

          <Link
            to="/core_values_list"
            className="btn btn-light btn-sm fw-semibold rounded-pill px-3"
          >
            Core Values List
          </Link>
        </div>

        {/* Card */}
        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            {loading && (
              <div className="text-center mb-3">
                <div className="spinner-border text-primary" />
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">शीर्षक (Title)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">क्रम (Display Order)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="display_order"
                    value={formData.display_order}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">वर्णन (Description)</label>
                  <textarea
                    className="form-control"
                    rows="5"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="mt-4 text-end">
                <button
                  type="submit"
                  className="btn btn-primary px-5 rounded-3 fw-bold shadow-sm"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "अपडेट होत आहे..." : "अपडेट करा"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EditCoreValue;